import React, { forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import Title from '@material-ui/icons/Title';

const TypeTxtShort = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Title {...props} ref={ref} />
));

TypeTxtShort.displayName = 'TypeTxtShort';

export default TypeTxtShort;
